// Add to this as new features are implemented
export default {
  SSO: 'SSO',
  CREDIT_CARD_ELIGIBILITY_LIMIT: 'CREDIT_CARD_ELIGIBILITY_LIMIT',
  EULA: 'EULA',
  SEPA: 'SEPA',
};
